type Part = string | RegExp | Expression
type Parts = (Part|Part[])[]

class Expression {
  protected readonly args: Parts
  constructor(...args: Parts) {
    this.args = args
  }
  group(capture?: boolean, recurse = false, recurring = false) {
    return new Group(...this.args).capture(capture, recurse, recurring)
  }
  capture(capture = true, recurse = false, recurring = false) {
    return this.group(capture, recurse, recurring)
  }
  regex(flags) {
    return new RegExp(this.toString(), flags)
  }
  toString() {
    return this.args.map(p => Expression.toString(p)).join('')
  }
  static or(parts) {
    return parts.map(p => Expression.toString(p)).join('|')
  }
  static toString(p) {
    return Array.isArray(p) ? Expression.or(p) : (p instanceof RegExp ? p.source : p.toString())
  }
}

class Group extends Expression {
  protected static readonly DEFAULT_CAPTURE: boolean = undefined
  protected readonly capt: boolean
  constructor(...args: Parts) {
    let capt
    if (args.length > 0 && typeof args[args.length - 1] === 'boolean') {
      capt = args.pop()
    }
    super(...args)
    //@ts-ignore
    const dflt = (this.constructor as typeof Group).DEFAULT_CAPTURE
    if (capt == undefined) capt = dflt
    this.capt = capt
  }

  capture(capture?: boolean, recurse = false, recurring = false) {
    let args = this.args
    if (recurse) {
      args = args.map(a =>
        (a instanceof Expression) ? a.capture(capture, recurse, true) : a
      )
    }
    // only reset capture flag if it was not explicitly set
    if (recurring && this.capt != undefined) return new Group(...args)
    //@ts-ignore
    return new Group(...args, capture)
  }
  toString() {
    const c = this.capt ? '' : '?:'
    return '(' + c + super.toString() + ')'
  }
}

class Capture extends Group {
  protected static readonly DEFAULT_CAPTURE = true
}

function E(...args) { return new Expression(...args) }
function G(...args) { return new Group(...args) }
function C(...args) { return new Capture(...args) }

export { E, G, C }